import { useContext } from 'react';

import { useMutation, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';

import { AlertSnackbarContext } from '../../../components/snackbars';
import Api from '../../api/api';

export const deleteAdvertisement = async (id: string) => {
  const [response, bodyOrError] = await Api.delete(`advertisement/${id}`);

  if (!response.ok) {
    throw bodyOrError;
  }
  return bodyOrError;
};

export const useDeleteAdvertisement = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [, setAlertSnackbar] = useContext(AlertSnackbarContext);

  return useMutation('deleteAdvertisement', deleteAdvertisement, {
    onSuccess: () => {
      queryClient.invalidateQueries(['getAdvertisementsByPage']);
      setAlertSnackbar({
        message: 'Advertisement deleted successfully.',
        severity: 'success',
        vertical: 'top',
      });
      navigate('/cms/advertisements');
    },
  });
};
